<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 27 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.375 19.25H2.875V17.3333H0.958333V19.25C0.958333 19.7583 1.16027 20.2458 1.51971 20.6053C1.87916 20.9647 2.36667 21.1667 2.875 21.1667H14.375C14.8833 21.1667 15.3708 20.9647 15.7303 20.6053C16.0897 20.2458 16.2917 19.7583 16.2917 19.25V17.3333H14.375V19.25ZM10.5417 2H2.875C2.36667 2 1.87916 2.20193 1.51971 2.56138C1.16027 2.92082 0.958333 3.40834 0.958333 3.91667V11.5833H2.875V3.91667H10.5417V7.75H14.375V11.5833H16.2917V7.75L10.5417 2ZM7.66667 15.4167H4.79167V13.5H7.66667V15.4167ZM12.4583 15.4167H9.58333V13.5H12.4583V15.4167ZM0 13.5H2.875V15.4167H0V13.5ZM17.25 15.4167H14.375V13.5H17.25V15.4167Z"
      :fill="color"
    />
    <path
      d="M21.2105 8H22.7895C22.9298 8 23 8.02963 23 8.08889V15.9111C23 15.9704 22.9298 16 22.7895 16H21.2105C21.0702 16 21 15.9704 21 15.9111V8.08889C21 8.02963 21.0702 8 21.2105 8Z"
      :fill="color"
    />
    <path
      d="M18.093 11H25.907C25.969 11 26 11.0702 26 11.2105V12.7895C26 12.9298 25.969 13 25.907 13H18.093C18.031 13 18 12.9298 18 12.7895V11.2105C18 11.0702 18.031 11 18.093 11Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPageBreakPlus',
  props: {
    width: {
      type: [String, Number],
      default: 27,
    },
    height: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>
